export default __webpack_public_path__ + "static/media/photo_daryl-and-sons.d865160c.jpg";